<template>
  <div class="orders-view">
    <orders-checker/>
  </div>
</template>

<script>
import OrdersChecker from '@/components/orders-checker'

export default {
  name: 'HistoryView',
  components: {
    OrdersChecker
  }
}
</script>

<style lang="scss" scoped>
  .orders-view {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/children/orders.view.vue